const userCenterRoute = {
  path: '/user-center',
  component: () => import('@/views/layout/user-center-layout/user-center-layout.vue').catch(() => location.reload()),
  meta: {
    title: '用户中心',
    requiredAuth: true,
  },
  children: [
    {
      path: '',
      redirect: 'account-info',
    },
    {
      path: 'account-info',
      component: () => import('@/views/user-center/account-info/account-info.vue').catch(() => location.reload()),
      meta: {
        title: '账户信息',
      },
    },
    {
      path: 'commission-account',
      component: () => import('@/views/user-center/commission-account/commission-account.vue').catch(() => location.reload()),
      meta: {
        title: '返佣账户',
        joinAuth: true, // 需要入驻权限
      },
    },
    {
      path: 'promotion-record',
      component: () => import('@/views/user-center/promotion-record/promotion-record.vue').catch(() => location.reload()),
      meta: {
        title: '推广记录',
        joinAuth: true,
      },
    },
    {
      path: 'promotion-material',
      component: () => import('@/views/user-center/promotion-material/promotion-material.vue').catch(() => location.reload()),
      meta: {
        title: '推广素材',
        joinAuth: true,
      },
    },
    {
      path: 'contract-list',
      component: () => import('@/views/user-center/contract-list/contract-list.vue').catch(() => location.reload()),
      meta: {
        title: '合同列表',
        joinAuth: true,
      },
    },
  ],
}

export default userCenterRoute
